<template>
  <router-view></router-view>
</template>


<script>
export default {
  name: "app",
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  mounted() {
    if (this._isMobile()) {
      localStorage.setItem("phone", 1);
    } else {
      localStorage.setItem("phone", 0);
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.v-note-wrapper .v-note-panel .v-note-show .v-show-content, .v-note-wrapper .v-note-panel .v-note-show .v-show-content-html{
  padding: 8px 0px 15px 0 !important;
}
.markdown-body img{
  max-width: 60% !important;
}
@import "./static/css/common.css";
@import "./static/css/wangEditor.css";
</style>
